import { Button, TableCell } from "@mui/material"

interface IDataTableCellButton {
    onClick: () => void,
    title: string,
    color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning'
}

const DataTableCellButton: React.FC<IDataTableCellButton> = (props) => {
    return (
        <TableCell style={{padding: 0}}>
            <Button onClick={props.onClick} variant="text" color={props.color}>
                {props.title}
            </Button>
        </TableCell>
    )
}

export default DataTableCellButton